import React, { useEffect, useState, useRef } from 'react';
import { useAdoption } from '../../context/AdoptionContext';
import '../../styles/Adoption.css';

function AdoptionTooltip({ content }) {
  const { dismissContent } = useAdoption();
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState(null);
  const tooltipRef = useRef(null);

  useEffect(() => {
    if (!content.target_selector) return;

    const el = document.querySelector(content.target_selector);
    if (!el) return;

    const show = () => {
      const rect = el.getBoundingClientRect();
      setPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + window.scrollX + rect.width / 2,
      });
      setVisible(true);
    };

    // Show on first render after a brief delay
    const timer = setTimeout(show, 500);
    return () => clearTimeout(timer);
  }, [content.target_selector]);

  if (!visible || !position) return null;

  return (
    <div
      className="adopt-tooltip"
      ref={tooltipRef}
      style={{ top: position.top, left: position.left }}
    >
      <div className="adopt-tooltip-arrow" />
      <div className="adopt-tooltip-body">
        {content.title && <div className="adopt-tooltip-title">{content.title}</div>}
        <div className="adopt-tooltip-text">{content.body}</div>
        {content.cta_text && (
          <button className="adopt-tooltip-cta" onClick={() => dismissContent(content.id)}>
            {content.cta_text}
          </button>
        )}
        <button className="adopt-tooltip-dismiss" onClick={() => dismissContent(content.id)}>
          Got it
        </button>
      </div>
    </div>
  );
}

export default AdoptionTooltip;
